import { DrawerProps, Drawer, Descriptions, Typography, Space, Tooltip, Divider, Checkbox, Image } from "antd";
import {
  Form,
  Row,
  Button,
  Col,
  UploadFile,
  Card,
} from "antd";
import SVGIcon from "../../../../utils/SVGIcon";
import Config from "../../../../config/Config";
import CancelButton from "../../../../components/Buttons/CancelButton";
import { useAppDispatch, useAppSelector } from "../../../../utils/hooks/hooks";
import { setFileRowData } from "../utils/slice";
import { formatEditor, renderNA } from "../../../../utils/commonFunctions";
import useColumnDefs from "../components/Listing/columnDefs";
import { genderOptions, INDUSTRY_FILTER, IMAGE_UPLOAD } from "../../../../config/Constant";
import dayjs from "dayjs";
import { dateFormats } from "../utils/constats";
import { AppDispatch, RootState } from "../../../../store/app";
import { useEffect, useState } from "react";
import AgGridWrapper from "../../../../components/AgGridWrapper/AgGridWrapper";
import { dateFormatter } from "../../../../config/Global";
import { fetchIndustryList, fetchIndustryWizeData } from "../../Industry/utils/slice";
import { masterObjectType } from "../utils/constats"
import { DownloadOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { fetchPrivilegesList } from "../../../../store/CommonSlice";

const { Title } = Typography;




interface ViewDrawerProps extends DrawerProps {
  titleName: string;
  open: boolean;
  close: () => void;
}

/**
 * Renders a view drawer component for displaying Import Activity details.
 *
 * @param {ViewDrawerProps} props - The component props.
 * @param {string} props.titleName - The title of the drawer.
 * @param {boolean} props.open - Whether the drawer is open or not.
 * @param {function} props.close - The function to close the drawer.
 * @param {...rest} props.rest - Additional props for the component.
 * @return {JSX.Element} The rendered view drawer component.
 */
const ViewDrawer: React.FC<ViewDrawerProps> = ({
  titleName,
  open,
  close,
  ...rest
}) => {
  var details = useAppSelector((state) => state.importActivity.details);


  const cusRowData: any = useAppSelector(
    (state: RootState) => state.importActivity.fileRowdata
  );
  const [showAgGrid, setShowAgGrid] = useState<boolean>(true);
  const agGridDisplay = showAgGrid ? { display: "block" } : { display: "none" };
  const dispatch: AppDispatch = useAppDispatch();
  const [isloading, setIsloading] = useState<any>(false);
  const [industryList, setIndustryList] = useState<any>([]);
  const [careerPath, setCareerPath] = useState<any>([]);
  const [skillCategory, setSkillCategory] = useState<any>([]);
  const [Ocupationalgroups, setOcupationalgroups] = useState<any>([]);
  const [CareerCategory, setCareerCategory] = useState<any>([]);
  const [privilegesList, setPrivilegesList] = useState<any[]>([]);


  useEffect(() => {

    if (
      open &&
      details?.payload?.question_industry_id &&
      details?.module == 'Interest Discovery'
    ) {
      setIsloading(true)

      dispatch(fetchIndustryList())
        .then((data: any) => {
          setIndustryList(data.rows);
        })
        .catch((error: any) => error);
      let id = details?.payload?.question_industry_id;
      console.log('details?.payload.industry_id',)
      dispatch(fetchIndustryWizeData([id],
        [
          INDUSTRY_FILTER.CAREER_CATEGORY,
          INDUSTRY_FILTER.SKILL_CATEGORY,
          INDUSTRY_FILTER.OCCUPATIONAL_GROUP,
          INDUSTRY_FILTER.CAREER_PATH,
        ]))
        .then((response: any) => {
          setIsloading(false)
          setCareerCategory(response.data.career_category.map((item: any) => {
            item.name = `${item.code} - ${item.name}`
            return item;
          }));
          setSkillCategory(response.data?.skill_category.map((item: any) => {
            item.name = `${item.code} - ${item.name}`
            return item;
          }) || []);
          setOcupationalgroups(response.data.occupational_group);
          setCareerPath(response.data?.career_path || []);
        })
        .catch((error: any) => error);





    }

    if (open &&
      details?.payload?.privileges &&
      details?.module == 'Roles') {

      setIsloading(true)
      dispatch(fetchPrivilegesList())
        .then((data: any) => {
          setIsloading(false)


          // Incoming privilege strings
          const newprevStr = details?.payload?.privileges;
          const oldprevStr = details?.payload?.old_privileges;

          // Normalize privilege strings → remove empty values caused by '#'
          const oldSet = new Set<string>(
            oldprevStr ? oldprevStr.split("#").filter(Boolean) : []
          );

          const newSet = new Set<string>(
            newprevStr ? newprevStr.split("#").filter(Boolean) : []
          );

          // If old privileges are null → do NOT mark anything as changed
          const hasOldData = oldSet.size > 0;

          // Build privilege tree
          const privileges = data.data.map((item: any) => {
            let anyChildChanged = false;
            let anyChildSelected = false;

            const child = item.child.map((childItem: any) => {
              const childId = String(childItem.id);

              const wasSelected = oldSet.has(childId);
              const isNowSelected = newSet.has(childId);

              // ✅ Added OR Removed → changed
              const isChanged = hasOldData
                ? wasSelected !== isNowSelected
                : false;

              if (isNowSelected) anyChildSelected = true;
              if (isChanged) anyChildChanged = true;

              return {
                ...childItem,
                selected: isNowSelected,
                isChanged
              };
            });

            return {
              ...item,

              // ✅ Parent is selected if ANY child is selected
              selected: anyChildSelected,

              child,

              // ✅ Parent is changed if ANY child changed
              isChanged: hasOldData ? anyChildChanged : false
            };
          });

          // Update state
          setPrivilegesList(privileges);



        })
        .catch((error: any) => error);


    }
    return () => {
      setIsloading(false)
    }
  }, [open]);



  // console.log('rowData', rowData)
  const drawerClose = () => {
    setShowAgGrid(false);

    close();
  };








  const get_object_name = (id: any, key: any, findKey: any = 'name') => {
    if (key == 'career_categories' || key == 'career_categories_old') {
      let data = CareerCategory?.find((data: any) => data.id == id);
      return data?.[findKey] || null;
    }
    else if (key == 'occupational_group' || key == 'occupational_group_old') {
      let data = Ocupationalgroups?.find((data: any) => data.id == id);
      return data?.[findKey] || null;
    }
    else if (key == 'career_path' || key == 'career_path_old') {
      let data = careerPath?.find((data: any) => data.id == id);
      return data?.[findKey] || null;
    }
    else if (key == 'skill_category' || key == 'skill_category_old') {
      let data = skillCategory?.find((data: any) => data.id == id);
      return data?.[findKey] || null;
    }
    return null;
  }

  const get_object_active = (key: any, object: any) => {
    if (key == 'career_categories' || key == 'career_categories_old') {
      return object?.career_category_flag || null;
    }
    else if (key == 'occupational_group' || key == 'occupational_group_old') {
      return object?.occupational_group_flag || null;
    }
    else if (key == 'career_path' || key == 'career_path_old') {
      return object?.career_path_flag || null;
    }
    else if (key == 'skill_category' || key == 'skill_category_old') {
      return object?.skill_category_flag || null;
    }
    return null;
  }


  const get_object_full = (arrayLimit: any, key: any) => {
    if (key == 'career_categories') {
      let data = CareerCategory?.filter((data: any) => arrayLimit.includes(data.id)).map((data: any) => data.name).join(', ');
      return data || null;
    }
    else if (key == 'occupational_group') {
      let data = Ocupationalgroups?.filter((data: any) => arrayLimit.includes(data.id)).map((data: any) => data.name).join(', ');
      return data || null;
    }

    return null;
  }




  console.log('masterObjectType', Object.keys(masterObjectType).length)
  const showObjectArray = (moduleName: any, payload: any) => {
    if (!masterObjectType.hasOwnProperty(moduleName)) {
      return null;
    }
    let moduleArray = masterObjectType[moduleName];
    console.log('moduleObject', moduleArray)
    if (moduleArray.length > 0) {
      let finalArray: any = [];
      for (let index = 0; index < moduleArray.length; index++) {
        const item = moduleArray[index];
        if (payload.hasOwnProperty(item.key)) {
          let value = payload[item.key];
          if (typeof value == 'object' && Array.isArray(value)) {
            value = value.join(', ');
          }
          else if (
            item.key == 'file' ||
            item.key == 'banner_logo' ||
            item.key == 'cc_hint_document'
          ) {
            value = import.meta.env.VITE_REACT_APP_IMAGE_API_URL + value;
          }
          else if (
            item.key == 'dob' ||
            item.key == 'end_date' ||
            item.key == 'start_date'
          ) {
            value = value != '' ? dateFormatter(value, dateFormats.dateFormat) : 'N/A';
          }
          else if (moduleName == 'Home Page') {
            let sectionArray: any = {
              'banner': 'Main section',
              'career_compass': 'Career Compass'
            };
            if (item.key == 'section') {
              value = sectionArray[value];
            }
          }
          finalArray.push(
            <Descriptions.Item key={item.key} label={item.title}>
              {/* {renderNA(formatEditor(value))} */}
              <div style={{ maxHeight: '25rem', width: '100%', overflow: 'auto' }} dangerouslySetInnerHTML={{ __html: renderNA(value) }}></div>
            </Descriptions.Item>
          );
        }
      }
      return finalArray;
    }
  }


  const GetUserModuleType = (action: any, moduleName: any, payload: any) => {

    // || action == 'Update Profile'
    if (action == 'Change Password' || action == 'Change Status') {
      return showObjectArray(action, payload);
    }


    if (moduleName == 'Profile') {
      let passaction = action == 'Edit' ? 'Update Profile' : action;
      return showObjectArray(passaction, payload);
    }
    return showObjectArray(moduleName, payload);
  }


  const tierOneMappingKeys = ['career_categories', 'occupational_group', 'career_path', 'skill_category'];
  const tierOneMappingKeysOld = ['career_categories_old', 'occupational_group_old', 'career_path_old', 'skill_category_old'];

  return (
    <Drawer
      title={`View ${titleName}`}
      open={open}
      placement="right"
      width={"80%"}
      onClose={drawerClose}
      destroyOnClose
      closeIcon={<SVGIcon icon="close" color={Config.themePrimaryBtn} />}
      footer={[<CancelButton key={2} onClick={drawerClose} />]}
      {...rest}
    >
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <Title level={5}>Log Details</Title>

        <Descriptions column={2} bordered layout="horizontal">
          <Descriptions.Item label="ID">
            {renderNA(details?.id)}
          </Descriptions.Item>

          <Descriptions.Item label="Module">
            {renderNA(details?.module)}
          </Descriptions.Item>
          <Descriptions.Item label="Action">
            {renderNA(details?.action)}
          </Descriptions.Item>
          <Descriptions.Item label="User Email">
            {renderNA(details?.created_by?.email)}
          </Descriptions.Item>
          <Descriptions.Item label="User Name">
            {renderNA(`${details?.created_by?.name} ${details?.created_by?.last_name}`)}
          </Descriptions.Item>
          <Descriptions.Item label="Role">
            {renderNA(details?.created_by?.role?.name)}
          </Descriptions.Item>
          <Descriptions.Item label="IP">
            {renderNA(details?.ip)}
          </Descriptions.Item>
          <Descriptions.Item label="Industry">
            {renderNA(details?.activity_industries_names?.map((data: any) => { return data })?.toString())}
          </Descriptions.Item>
          <Descriptions.Item label="Logged At">
            {renderNA(dateFormatter(details?.created_at, dateFormats.datetimeFormat))}
          </Descriptions.Item>
        </Descriptions>



        <Title level={5}>Activity</Title>

        {details?.payload && <Descriptions styles={{ label: { width: '50%' } }} column={1} bordered layout="horizontal">
          {GetUserModuleType(details?.action, details?.module, details?.payload)}
        </Descriptions>}
        {!isloading && details?.payload && <>
          {
            details?.module == 'Interest Discovery' &&
            <>
              {
                details?.payload?.type == 'General Question' &&
                (details?.payload?.career_categories || details?.payload?.occupational_group) &&
                <Descriptions title="Mapping" column={1} bordered layout="horizontal">
                  {
                    details?.payload?.career_categories && details?.payload?.career_categories?.length > 0 &&
                    <Descriptions.Item label={'Career Categories'}>
                      {renderNA(get_object_full(details?.payload?.career_categories, 'career_categories'))}
                    </Descriptions.Item>
                  }
                  {
                    details?.payload?.occupational_group && details?.payload?.occupational_group?.length > 0 &&
                    <Descriptions.Item label={'Occupational Group'}>
                      {renderNA(get_object_full(details?.payload?.occupational_group, 'occupational_group'))}
                    </Descriptions.Item>
                  }

                </Descriptions>
              }
              {details?.payload?.type != 'General Question' && details?.payload?.mapping && details?.payload?.mapping?.length > 0 &&
                <Descriptions title={
                  <Space align="center">
                    Mapping

                    {details?.action == 'Edit' && <Tooltip title="Items highlighted in green indicate newly added items and red are deleted items. " >
                      <InfoCircleOutlined />
                    </Tooltip>}
                  </Space>

                }
                  column={4} classNames={{ label: 'custom-header', content: 'custom-body' }} bordered layout="vertical">
                  {details?.payload?.mapping.map((item: any) => {
                    return Object.keys(item).map((subItem) => {
                      if (
                        tierOneMappingKeys.includes(subItem) &&
                        !item?.is_delete_record
                      ) {
                        return <Descriptions.Item key={subItem + item + 'new'} className={get_object_active(subItem, item) ? 'active' : ''} label={subItem.toTitleCase()}>
                          <>
                            {item[subItem] && tierOneMappingKeys.includes(subItem) &&
                              <>
                                <div title={(get_object_active(subItem, item) ? "New Record" : '')} className={'cust-td ' + (get_object_active(subItem, item) ? 'active' : '')}>
                                  {renderNA(get_object_name(item[subItem], subItem))}
                                </div>
                              </>
                            }
                            {item[subItem] && item[`${subItem}_old`] && item[subItem] != item[`${subItem}_old`] && item[`${subItem}_old`] && tierOneMappingKeysOld.includes(`${subItem}_old`) &&
                              <>
                                <div title="Old Record" className={'cust-td delete'}>
                                  {renderNA(get_object_name(item[`${subItem}_old`], `${subItem}_old`))}
                                </div>
                              </>
                            }
                          </>
                        </Descriptions.Item>
                      }
                      else if (
                        tierOneMappingKeysOld.includes(subItem) &&
                        item[subItem] &&
                        item.is_delete_record
                      ) {
                        return <Descriptions.Item key={subItem + item + 'deleted'} className={get_object_active(subItem, item) ? 'delete' : ''} label={subItem.replace('_old', '').toTitleCase()}>
                          <div title="Old Record" className={'cust-td ' + (get_object_active(subItem, item) ? 'delete' : '')}>
                            {renderNA(get_object_name(item[subItem], subItem))}
                          </div>
                        </Descriptions.Item>
                      }

                    }).filter((data: any) => data)
                  })}

                </Descriptions>
              }
            </>
          }
          {
            details?.module == 'Roles' &&
            details?.payload?.privileges &&
            privilegesList.length > 0 &&
            <>
              <Card title={<>Privileges {details?.action == 'Edit' && <Tooltip title="Items highlighted in green indicate successful updates or newly added items. " >
                <InfoCircleOutlined />
              </Tooltip>}</>}>
                {privilegesList.map((item: any) => {
                  let allChecked = 0;
                  item?.child.map((action: any) => {
                    if (action.selected) {
                      allChecked++;
                    }
                  });
                  return (
                    <Row gutter={15} key={item.id}>
                      <Card className="mt-10" style={{ width: "100%" }}>
                        <Row gutter={15} key={item.id}>
                          <Col
                            xs={{ span: 4 }}
                            style={{ borderRight: "1px solid #f0f0f0" }}
                          >
                            <b>{item.name}</b>
                          </Col>
                          <Col xs={{ span: 20 }}>

                            {/* <Divider type="vertical" /> */}
                            {item?.child.map(
                              (subPrivilege: any, index: number) => {
                                return (
                                  <>
                                    <div
                                      key={index}
                                      style={{ display: "inline-block" }}
                                      className={'log-privileges ' + (subPrivilege.isChanged ? 'active' : '')}
                                    >
                                      <Checkbox
                                        className="disabled"
                                        checked={subPrivilege.selected}

                                      >
                                        {subPrivilege.name}
                                      </Checkbox>
                                    </div>
                                    <Divider type="vertical" />
                                  </>
                                );
                              }
                            )}
                          </Col>
                        </Row>
                      </Card>
                    </Row>
                  );
                })}
              </Card>
            </>
          }
          {
            details?.module == 'Home Page' &&
            <>
              {
                details?.payload?.banner_logo &&
                <Descriptions column={1} styles={{ label: { width: '50%' } }} bordered layout="horizontal">
                  <Descriptions.Item label={'Main Logo'}>
                    <Image
                      width={200}
                      alt="basic"
                      src={IMAGE_UPLOAD + details?.payload?.banner_logo}

                    />
                  </Descriptions.Item>
                </Descriptions>
              }
              {
                details?.payload?.cc_hint_document &&
                <Descriptions column={1} styles={{ label: { width: '50%' } }} bordered layout="horizontal">
                  <Descriptions.Item label={'Hint Document'}>
                    <Button type="primary" target="_blank" href={IMAGE_UPLOAD + details?.payload?.cc_hint_document} icon={<DownloadOutlined />} >
                      Download
                    </Button>
                  </Descriptions.Item>
                </Descriptions>
              }
              {
                details?.payload?.cc_hint_document_spanish &&
                <Descriptions column={1} styles={{ label: { width: '50%' } }} bordered layout="horizontal">
                  <Descriptions.Item label={'Hint Document (Spanish)'}>
                    <Button type="primary" target="_blank" href={IMAGE_UPLOAD + details?.payload?.cc_hint_document_spanish} icon={<DownloadOutlined />} >
                      Download
                    </Button>
                  </Descriptions.Item>
                </Descriptions>
              }
            </>
          }
          {
            details?.module == 'Careers' &&
            <>
              {
                details?.payload?.file &&
                <Descriptions column={1} styles={{ label: { width: '50%' } }} bordered layout="horizontal">
                  <Descriptions.Item label={'Image'}>
                    <Image
                      width={200}
                      alt="basic"
                      src={IMAGE_UPLOAD + details?.payload?.file}

                    />
                  </Descriptions.Item>
                </Descriptions>
              }
            </>
          }

        </>}
        {isloading && <>Loading...</>}

      </Space>









    </Drawer>
  );
};

export default ViewDrawer;
